module.exports = __webpack_public_path__ + "static/media/switch_mandatory_off.8edc9f39.png";